<template>
  <v-row v-if="sdaData && filteredExhaustedItems.length > 0">
    <v-col cols="12">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="grey" class="mr-2">mdi-package-variant-closed</v-icon>
          Εξαντλημένα Προϊόντα ({{ filteredExhaustedItems.length }}/{{ exhaustedItems.length }})
        </v-card-title>
        <v-list>
          <SDAProductItem
            v-for="item in filteredExhaustedItems"
            :key="'exhausted-' + item.PartnerMvItm_ID"
            :item="item"
            :selected-quantity="0"
            :disabled="true"
            :only-show-s-d-a-inv="onlyShowSDAInv"
            @info-click="$emit('info-click', $event)"
          />
        </v-list>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import SDAProductItem from './SDAProductItem.vue'

export default {
  name: 'SDAExhaustedProducts',
  components: {
    SDAProductItem
  },
  props: {
    sdaData: {
      type: Object,
      default: null
    },
    search: {
      type: String,
      default: ''
    },
    onlyShowSDAInv: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    exhaustedItems() {
      if (!this.sdaData?.SDAInv?.SDAItems) return []
      return this.sdaData.SDAInv.SDAItems.filter(item => item.AvailPosot === 0)
    },
    filteredExhaustedItems() {
      return this.exhaustedItems.filter(item => 
        item.ProductName.toLowerCase().includes(this.search.toLowerCase()) ||
        item.Product_ID.toLowerCase().includes(this.search.toLowerCase())
      )
    }
  }
}
</script> 